import gql from 'graphql-tag';
import Member from './Member';

export default gql`
    fragment Pickup on CMPickup {
        ID
        Date
        Time
        CoffinSize
        Comment
        AssignedStaff {
            ...Member
        }
    }
    ${Member}
`;